import { ArticleCategoryModel } from "../../models/articles-category/ArticleCategoryModel";
import { ApiBase } from "../../base/_ApiBase";

export const ArticleCategoryApi = new class ArticleCategoryApi extends ApiBase<ArticleCategoryModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
}({ baseUrl: '/articles-category' });